"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDecimalPlaces = exports.SIUnit = exports.genContext = exports.genLabel = void 0;
var convert_units_1 = __importDefault(require("convert-units"));
exports.genLabel = function (props, measurementUnit) {
    var defaultUnit = props.defaultUnit, showUnits = props.showUnits, metricUnit = props.metricUnit, imperialUnit = props.imperialUnit;
    if (showUnits) {
        var con = exports.genContext(props, measurementUnit);
        var unit = convert_units_1.default().describe(defaultUnit);
        if (con === 'm') {
            unit = convert_units_1.default().describe(metricUnit);
        }
        else if (con === 'i') {
            unit = convert_units_1.default().describe(imperialUnit);
        }
        return '\xa0' + exports.SIUnit(unit.abbr);
    }
    else {
        return '';
    }
};
exports.genContext = function (props, measurementUnits) {
    var metricUnit = props.metricUnit, imperialUnit = props.imperialUnit;
    if (measurementUnits) {
        if (measurementUnits === 'metric' && metricUnit) {
            return 'm';
        }
        else if (measurementUnits === 'imperial' && imperialUnit) {
            return 'i';
        }
    }
    return 'd';
};
exports.SIUnit = function (textUnit) {
    switch (textUnit) {
        case 'C':
            return '°C';
        case 'F':
            return '°F';
        case 'R':
            return '°R';
        default:
            return textUnit.replace('2', '²').replace('3', '³');
    }
};
exports.setDecimalPlaces = function (value, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 0; }
    var multiplier = Math.pow(10, decimalPlaces);
    return (Math.round(value * multiplier) / multiplier);
};
